import   { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import useFormErrorHighlight from '../../../hooks/useFormErrorHighlight'
import axios from 'axios';
import { Helmet } from 'react-helmet-async';


const ClientBeneficiaryForm_ForUpdate = ({  personType, onChange, div_to_scroll_index, errorMessage, title, handleDelete , formData }) => {


    const [formFields, setFormFields] = useState(formData);

    const [divVoterVisibility, setDivVoterVisibility] = useState(false);
    const districtFieldName = `${personType}_district`;
    const districtErrorMessage = errorMessage && errorMessage.errors && errorMessage.errors[districtFieldName];

    const getFieldErrorMessage = useFormErrorHighlight(errorMessage);



    // Initialize form fields state
    useEffect(() => {
        if (formData) {
            setFormFields(prevFields => ({
                ...prevFields,
                ...formData,
            }));

            console.log(formData);
        }
        console.log(formData);
    }, [formData, personType]);

    // Handler to update form fields and trigger onChange
    const handleFieldChange = (fieldName, value) => {
        const updatedFields = { ...formFields, [fieldName]: value };
        setFormFields(updatedFields);
        onChange(updatedFields);

    };


    const [data, setData]             = useState([]);
    const [count, setCount]           = useState(0);
    const [searchTerm, setSearchTerm] = useState('')

    useEffect(() => {

        if (searchTerm !== "") {
            const delayDebounceFn = setTimeout(async () => {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/voters/?search=${searchTerm}`);
                setData(response.data.results);
                setCount(response.data.count)
                setDivVoterVisibility(true);
                console.log(response.data);
            }, 750)

            return () => clearTimeout(delayDebounceFn)
        }
        else {
            setData(null);
        }


    }, [searchTerm])


    const colors = ['danger', 'primary', 'success', 'info', 'warning'];

      // FOR LOCATION: DISTRICT, MUNICIPALITY, BARANGAY
    const [cachedData,      setCachedData]        = useState([]);
    const [districtList,    setDistrictList]      = useState([]);
    const [district,        setDistrict]          = useState('');
    const [municipalityList, setMunicipalityList] = useState([]);
    const [municipality,    setMunicipality]      = useState('');
    const [barangayList,    setBarangayList]      = useState([]);
    const [barangay,        setBarangay]          = useState('');

    useEffect(() => {
        const cachedDataString = localStorage.getItem('cachedData');
        if (cachedDataString) {
            const parsedCachedData = JSON.parse(cachedDataString);
            setCachedData(parsedCachedData);
        }
    }, []);

    // Update district, municipality, and barangay from formData
    useEffect(() => {
        setDistrict(formData[`${personType}_district`] || '');
        setMunicipality(formData[`${personType}_municipality`] || '');
        setBarangay(formData[`${personType}_barangay`] || '');
    }, [formData, personType]);

    useEffect(() => {
        // GETTING ALL DISTRICTS ONLY
        const uniqueDistricts = [...new Set(cachedData.map(location => location.location_district))];
        const sortedDistricts = uniqueDistricts.sort((a, b) => {
            const numA = parseInt(a.match(/\d+/)[0]);
            const numB = parseInt(b.match(/\d+/)[0]);
            return numA - numB;
        });
        setDistrictList(sortedDistricts);
    }, [cachedData]);

    useEffect(() => {
        if (district) {
            const municipalities = cachedData
                .filter(location => location.location_district === district)
                .map(location => location.location_municipality)
                .sort((a, b) => a.localeCompare(b));
            const uniqueMunicipalities = [...new Set(municipalities)];
            setMunicipalityList(uniqueMunicipalities);
        }
    }, [district, cachedData]);

    useEffect(() => {
        if (district && municipality) {
            const barangays = cachedData
                .filter(location => location.location_district === district && location.location_municipality === municipality)
                .map(location => location.location_barangay)
                .sort((a, b) => a.localeCompare(b));
            const uniqueBarangays = [...new Set(barangays)];
            setBarangayList(uniqueBarangays);
        }
    }, [district, municipality, cachedData]);

    const handleDistrictChange = (selectedDistrict) => {
        setDistrict(selectedDistrict);
        setMunicipality('');
        setBarangay('');
    };

    const handleMunicipalityChange = (selectedMunicipality) => {
        setMunicipality(selectedMunicipality);
        setBarangay('');
    };

    const handleBarangayChange = (selectedBarangay) => {
        setBarangay(selectedBarangay);
    };


    const [selectedDate, setSelectedDate] = useState(null);
    const handleDateChange = (date) => {
        date.setHours(0, 0, 0, 0);
        const formattedDate = date.toISOString().slice(0, 10);
        setSelectedDate(date);

        // Update form data
        setFormFields(prevData => ({
            ...prevData,
            [`${personType}_birthdate`]: formattedDate
        }));
    };



    const handleRowClick = (rowData) => {
        setDivVoterVisibility(false)
        // Update form data with the clicked row's data

        setMunicipalityList([]);
        setBarangayList([]);

        setMunicipality('');
        setBarangay('');


        setDistrict(rowData.voter_district);
        setMunicipality(rowData.voter_municipality);
        setBarangay(rowData.voter_barangay);


        setFormFields({
            ...formData,
            [`${personType}_voter_id`]                     : rowData.voter_id ?? "",
            [`${personType}_fullname`]                     : rowData.voter_name ?? "",
            [`${personType}_address`]                      : rowData.voter_address ?? "",
            [`${personType}_gender`]                       : (rowData.voter_gender ?? "").toLowerCase(),
            [`${personType}_birthdate`]                    : rowData.voter_birthday ?? "",
            [`${personType}_district`]                     : rowData.voter_district ?? "",
            [`${personType}_municipality`]                 : rowData.voter_municipality ?? "",
            [`${personType}_barangay`]                     : rowData.voter_barangay ?? "",
            [`${personType}_sitio`]                        : rowData.voter_sitio ?? "",
            [`${personType}_contact`]                      : rowData.voter_contact ?? "",
            [`${personType}_email`]                        : rowData.voter_fb_email ?? "",
            [`${personType}_isVoter`]                      : rowData.isVoter ?? "",
            [`${personType}_household_id`]                 : rowData.voter_household_id ?? "",
            [`${personType}_household_role`]               : rowData.voter_household_role ?? "",
            [`${personType}_government_position`]          : rowData.voter_government_position ?? "",
            [`${personType}_voter_cluster_number`]         : rowData.voter_cluster_number ?? "",
            [`${personType}_voter_clustered_polling_place`]: rowData.voter_clustered_polling_place ?? "",
            [`${personType}_voter_clustered_precinct`]     : rowData.voter_clustered_precinct ?? "",
            [`${personType}_voter_id_status`]              : rowData.voter_id_status ?? "",
            [`${personType}_voter_image_path`]             : rowData.voter_image_path ?? "",
            [`${personType}_voter_leader`]                 : rowData.voter_leader ?? "",
            [`${personType}_voter_org`]                    : rowData.voter_org ?? "",
            [`${personType}_voter_org_2`]                  : rowData.voter_org_2 ?? "",
            [`${personType}_voter_poll_watcher_workers`]   : rowData.voter_poll_watcher_workers ?? "",
            [`${personType}_voter_religion`]               : rowData.voter_religion ?? "",
            [`${personType}_voter_sector`]                 : rowData.voter_sector ?? "",
            [`${personType}_voter_status`]                 : rowData.voter_status ?? "",
            [`${personType}_voter_structure_code`]         : rowData.voter_structure_code ?? "",
            [`${personType}_voter_structure_name`]         : rowData.voter_structure_name ?? "",
            [`${personType}_voter_vital_status`]           : rowData.voter_vital_status ?? "",
            [`${personType}_voter_working_status`]         : rowData.voter_working_status ?? "",

        });

        const birthdate = new Date(rowData.voter_birthday) ?? "";
        setSelectedDate(birthdate);
        

        handleDistrictChange(rowData.voter_district);
        handleMunicipalityChange(rowData.voter_municipality);
        handleBarangayChange(rowData.voter_barangay);

    };


    const resetForm = () => {
        setFormFields([]);

        handleDistrictChange('');
        handleMunicipalityChange('');
        handleBarangayChange('');
      };
 

    return (
        <>
           
            <div id={`div_to_scroll_${div_to_scroll_index}`} className="card mb-4"  >
                <div className="card-header d-flex justify-content-between mx-2">
                    <h5 className="card-title m-0 text-info">{title.toUpperCase()} DETAILS</h5>

                    {handleDelete && ( // Check if handleDelete is provided
                        <button onClick={handleDelete} className="btn btn-danger">Delete Member</button>
                    )}
                </div>
                <div className="card-body">



                    <div className="row mb-3 g-3">
                        <div className="col-12">


                            <label className="form-label text-info mb-0" htmlFor={`${personType}_search`}>Search Voter</label>
                            <div className="input-group">
                                <input type="search" className="form-control" id={`${personType}_search`} name={`${personType}_search`} onChange={(e) => setSearchTerm(e.target.value)} placeholder="Voter name..." />
                                <button className="btn btn-outline-primary" type="button" id="button-addon2" onClick={resetForm}>Clear Form</button>
                            </div>


                            <div className={divVoterVisibility ? 'd-block' : 'd-none'}>

                                {data && count == 0 ?
                                    <div className="list-group mt-1">
                                        <li className="list-group-item list-group-item-action d-flex justify-content-between">
                                            <div className="li-wrapper d-flex justify-content-start align-items-center">
                                                <div className="list-content text-info">
                                                    NO DATA FOUND
                                                </div>
                                            </div>
                                        </li>
                                    </div>
                                    :
                                    data && data.map((row, index) => (
                                        <div key={index} className="list-group mt-1">
                                            <button type="button" className="list-group-item list-group-item-action d-flex justify-content-between" onClick={() => handleRowClick(row)}>

                                                <table className='w-100'>
                                                    <tbody>
                                                        <tr>
                                                            <td width="250">
                                                                <div className="li-wrapper d-flex  align-items-center">

                                                                    {row.voter_image_path ?
                                                                        <img src={row.voter_image_path} alt="User Image" className="rounded-circle me-3 w-px-50"></img>
                                                                        :
                                                                        <div className="avatar avatar-sm me-3">
                                                                            <span className={`avatar-initial rounded-circle bg-label-${colors[index % colors.length]}`}>{row.voter_name[0].toUpperCase()}</span>
                                                                        </div>
                                                                    }

                                                                    <div className="list-content">
                                                                        <h6 className="mb-1">{row.voter_name?.toUpperCase()}</h6>
                                                                        <small className="text-muted">Birthday: {row.voter_birthday}</small>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td width="150">
                                                                <div className="list-content  text-center ">
                                                                    <h6 className="mb-1">{row.voter_municipality}</h6>
                                                                    <small className="text-muted">Municipality</small>
                                                                </div>
                                                            </td>
                                                            <td width="150">
                                                                <div className="list-content  text-center ">
                                                                    <h6 className="mb-1">{row.voter_barangay}</h6>
                                                                    <small className="text-muted">Barangay</small>
                                                                </div>
                                                            </td>
                                                            <td width="150">
                                                                <div className="list-content  text-center ">
                                                                    <h6 className="mb-1">{row.voter_precinct_no}</h6>
                                                                    <small className="text-muted">Precinct</small>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>



                                            </button>
                                        </div>
                                    ))}

                            </div>


                        </div>


                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-12">
                            <div className="divider divider-primary">
                                <div className="divider-text">OR</div>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_fullname`}>Enter Fullname</label>
                            <input type="text" className="form-control" id={`${personType}_fullname`}  name={`${personType}_fullname`} value={formFields[`${personType}_fullname`]} onChange={(e) => handleFieldChange(`${personType}_fullname`, e.target.value)}
                                placeholder="last, first middle suffix" aria-label="settings Details"
                                style={{ borderColor: useFormErrorHighlight(`${personType}_fullname`) }} />
                        </div>
                        <div className="col-12 col-md-6 d-none">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_voter_id`}>CVL ID</label>
                            <input type="text" className="form-control" id={`${personType}_voter_id`} name={`${personType}_voter_id`} value={formFields[`${personType}_voter_id`]} onChange={(e) => handleFieldChange(`${personType}_voter_id`, e.target.value)} />
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_email`}>Email</label>
                            <input type="email" className="form-control" id={`${personType}_email`} name={`${personType}_email`} value={formFields[`${personType}_email`]} onChange={(e) => handleFieldChange(`${personType}_email`, e.target.value)} placeholder="john@gmail.com" aria-label="email" />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_contact`}>Contact</label>
                            <input type="number" id={`${personType}_contact`} name={`${personType}_contact`} value={formFields[`${personType}_contact`]} onChange={(e) => handleFieldChange(`${personType}_contact`, e.target.value)} className="form-control" placeholder="Contact" min={0} max={999999} />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_gender`}>Gender</label>
                            <select id={`${personType}_gender`} name={`${personType}_gender`} value={formFields[`${personType}_gender`]} onChange={(e) => handleFieldChange(`${personType}_gender`, e.target.value)} className="select2 form-select" data-placeholder="Gender">
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                            </select>
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_birthdate`} >Birthday</label>
                            <DatePicker id={`${personType}_birthdate`}
                                name={`${personType}_birthdate`}
                                className='form-control  flatpickr-input active'
                                placeholderText='YYYY-MM-DD'
                                // selected={FormDatas[`${personType}_birthdate`]}
                                selected={selectedDate}
                                onChange={handleDateChange}
                                dateFormat="yyyy-MM-dd"
                                value={formFields[`${personType}_birthdate`]}
                            />
                        </div>



                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_address`}>Address</label>
                            <input type="text" className="form-control" id={`${personType}_address`} value={formFields[`${personType}_address`]} onChange={(e) => handleFieldChange(`${personType}_address`, e.target.value)} name={`${personType}_address`} placeholder="Address" aria-label="email" />
                        </div>


                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_district`}>District</label>
                            <select id={`${personType}_district`} name={`${personType}_district`} value={district} onChange={(e) => {
                                handleDistrictChange(e.target.value);
                                handleFieldChange(`${personType}_district`, e.target.value);
                            }} className="select2 form-select" data-placeholder="District" style={{ borderColor: districtErrorMessage ? 'red' : '' }}>
                                <option value="">Select District</option>
                                {districtList.map((district, index) => (
                                    <option key={index} value={district}>{district}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_municipality`}>Municipality</label>
                            <select id={`${personType}_municipality`} name={`${personType}_municipality`} value={municipality} onChange={(e) => {
                                handleMunicipalityChange(e.target.value);
                                handleFieldChange(`${personType}_municipality`, e.target.value);
                            }} className="select2 form-select" data-placeholder="Municipality">
                                <option value="">Select Municipality</option>
                                {municipalityList.map((municipality, index) => (
                                    <option key={index} value={municipality}>{municipality}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_barangay`}>Barangay</label>
                            <select id={`${personType}_barangay`} name={`${personType}_barangay`} value={barangay} onChange={(e) => {
                                handleBarangayChange(e.target.value);
                                handleFieldChange(`${personType}_barangay`, e.target.value);
                            }} className="select2 form-select" data-placeholder="Barangay">
                                <option value="">Select Barangay</option>
                                {barangayList.map((barangay, index) => (
                                    <option key={index} value={barangay}>{barangay}</option>
                                ))}
                            </select>
                        </div>


                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_sitio`}>Sitio</label>
                            <input type="text" className="form-control" id={`${personType}_sitio`} value={formFields[`${personType}_sitio`]} onChange={(e) => handleFieldChange(`${personType}_sitio`, e.target.value)} name={`${personType}_sitio`} placeholder="Sitio" />
                        </div>


   {/* 
                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_sector`}>Sector</label>
                            <select id={`${personType}_sector`} name={`${personType}_sector`} value={formFields[`${personType}_sector`]} onChange={(e) => handleFieldChange(`${personType}_sector`, e.target.value)} className="select2 form-select" data-placeholder="Sector">
                                <option value=""></option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                            </select>
                        </div>

                      
                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_father_name`}>Father's Name</label>
                            <input type="text" className="form-control" id={`${personType}_father_name`} value={formFields[`${personType}_father_name`]} onChange={(e) => handleFieldChange(`${personType}_father_name`, e.target.value)} placeholder="Father's Name" />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_mother_name`}>Mother's name</label>
                            <input type="text" className="form-control" id={`${personType}_mother_name`} value={formFields[`${personType}_mother_name`]} onChange={(e) => handleFieldChange(`${personType}_mother_name`, e.target.value)} placeholder="Mother's Name" />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_family_id`}>Family ID</label>
                            <input type="text" className="form-control" id={`${personType}_family_id`} value={formFields[`${personType}_family_id`]} onChange={(e) => handleFieldChange(`${personType}_family_id`, e.target.value)} placeholder="Family ID (optional)" />
                        </div>

                       <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_family_role`}>Role in the Family</label>
                            <select id={`${personType}_family_role`} name={`${personType}_family_role`} value={formFields[`${personType}_family_role`]} onChange={(e) => handleFieldChange(`${personType}_family_role`, e.target.value)} className="select2 form-select" data-placeholder="Role">
                                <option value=""></option>
                                <option value="Head">Head</option>
                                <option value="Father">Father</option>
                                <option value="Mother">Mother</option>
                                <option value="Child">Child</option>
                            </select>
                        </div> */}


                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_civil_status`}>Civil Status</label>
                            <select id={`${personType}_civil_status`} name={`${personType}_civil_status`} value={formFields[`${personType}_civil_status`]} onChange={(e) => handleFieldChange(`${personType}_civil_status`, e.target.value)} className="select2 form-select" data-placeholder="Civil Status">
                                <option value="">Select Civil Status</option>
                                <option value="Single">Single</option>
                                <option value="Married">Married</option>
                                <option value="Separated">Separated</option>
                                <option value="Widowed">Widowed</option>
                            </select>
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_place_of_birth`}>Place of Birth</label>
                            <input type="text" className="form-control" id={`${personType}_place_of_birth`} name={`${personType}_place_of_birth`} value={formFields[`${personType}_place_of_birth`]} onChange={(e) => handleFieldChange(`${personType}_place_of_birth`, e.target.value)} placeholder="Place of Birth" />
                        </div>




                    </div>

                </div>
            </div>


        </>
    );
}

export default ClientBeneficiaryForm_ForUpdate;
